module.exports = __webpack_public_path__ + "static/media/dkbg_911Ready_logo.ae803793.png";